@if (productModel?.id) {
<div
    class="flex flex-wrap gap-4 w-full"
    [attr.data-testid]="props.attributes?.['data-testid'] ?? 'formly-product-calculatory-costs'"
>
    <div class="w-full md:w-1/2 flex flex-col gap-1">
        <label class="text-sm font-medium">{{
            'product.calculatory-costs-source-mode' | translate
        }}</label>
        <phx-select
            [items]="sourceModeItems()"
            optionLabel="label"
            optionValue="value"
            [value]="sourceMode()"
            (onModelChange)="onSourceModeChange($event)"
            [dataTestId]="'formly-product-calculatory-costs-source-mode'"
        />
    </div>

    @if (usesTenantDefault()) {
        <div class="w-full">
            <p
                class="text-sm text-muted-color"
                [attr.data-testid]="'formly-product-calculatory-costs-tenant-default-hint'"
            >
                {{ 'product.calculatory-costs-tenant-default-hint' | translate }}
            </p>
        </div>
    }

    @if (isExpression()) {
        <div class="w-full md:w-1/2 flex flex-col gap-1">
            <label class="text-sm font-medium">{{
                'product.calculatory-costs-expression-binding-mode' | translate
            }}</label>
            <phx-select
                [items]="expressionBindingModeItems()"
                optionLabel="label"
                optionValue="value"
                [value]="expressionBindingMode()"
                (onModelChange)="onExpressionBindingModeChange($event)"
                [dataTestId]="'formly-product-calculatory-costs-expression-binding-mode'"
            />
        </div>
    }

    @if (isExpression()) {
        <div class="w-full md:w-1/2 flex flex-col gap-1">
            <label class="text-sm font-medium">{{
                'product.calculatory-costs-expression-engine' | translate
            }}</label>
            <phx-select
                [items]="engineItems()"
                optionLabel="label"
                optionValue="value"
                [value]="expressionEngine() ?? CalculatoryCostsExpressionEngine.JSONATA"
                (onModelChange)="onEngineChange($event)"
                [dataTestId]="'formly-product-calculatory-costs-engine'"
            />
        </div>
    }

    @if (isSchemaExpression()) {
        <div class="w-full md:w-1/2 flex flex-col gap-1">
            <label class="text-sm font-medium">{{
                'entities.Product.calculatoryCostsExpressionSchemaId' | translate
            }}</label>
            <app-formly-jso-nata-schemas-drop-down
                [selectedId]="productModel.calculatoryCostsExpressionSchemaId ?? ''"
                (selectedIdChange)="onExpressionSchemaIdChange($event)"
                [modelMode]="'IdOnly'"
                [schemaVariant]="productCostsSchemaVariant"
                [jsonataEditorSource]="calculatoryCostsJsonataEditorSource()"
                [jsonataExpressionTemplates]="CALCULATORY_COSTS_JSONATA_EXPRESSION_TEMPLATES"
                jsonataEditorHintKey="product.calculatory-costs-expression-dialog-hint"
                jsonataEditorTitle="product.calculatory-costs-expression-dialog-title"
                [dataTestId]="'formly-product-calculatory-costs-expression-schema'"
            />
        </div>
    }

    <div class="w-full md:w-1/2 flex flex-col gap-1">
        <label class="text-sm font-medium">{{ 'product.calc-price' | translate }}</label>
        <app-phx-input-number
            [ngModel]="productModel.calculatoryCosts"
            (ngModelChange)="onCalculatoryCostsChange($event)"
            [disabled]="priceDisabled()"
            [dataTestId]="'formly-product-calculatory-costs-value'"
        />
    </div>
    @if (isInlineExpression()) {
        <div class="w-full">
            <p-button
                severity="secondary"
                [label]="'product.calculatory-costs-edit-expression' | translate"
                icon="fas fa-code"
                (onClick)="openExpressionDialog()"
                [attr.data-testid]="'formly-product-calculatory-costs-edit-expression'"
            />
        </div>
    }

    @if (isPlugin()) {
        <div class="w-full md:w-1/2 flex flex-col gap-1">
            <label class="text-sm font-medium">{{
                'entities.Product.calculatoryCostsStrategyCode' | translate
            }}</label>
            <input
                type="text"
                class="w-full p-inputtext p-component"
                [(ngModel)]="productModel.calculatoryCostsStrategyCode"
                (ngModelChange)="onStrategyCodeChange()"
                [attr.data-testid]="'formly-product-calculatory-costs-strategy-code'"
            />
        </div>
    }

    @if (showRecalculate()) {
        <div class="w-full flex flex-wrap items-center gap-2">
            <p-button
                [label]="'product.calculatory-costs-recalculate' | translate"
                icon="fas fa-sync"
                [loading]="recalculating()"
                [disabled]="!productModel.id"
                (onClick)="recalculateNow()"
                [attr.data-testid]="'formly-product-calculatory-costs-recalculate'"
            />
            @if (productModel.calculatoryCostsCalculatedAt) {
                <span class="text-sm text-muted-color">
                    {{ 'product.calculatory-costs-calculated-at' | translate }}:
                    {{ productModel.calculatoryCostsCalculatedAt | localeDate: 'medium' }}
                </span>
            }
        </div>
    }
</div>
} @else {
    <div
        class="flex justify-center items-center choose-ngifloader-splitter h-full w-full min-h-[400px]"
        [attr.data-testid]="'formly-product-calculatory-costs-no-product-id'"
    >
        <div class="shine">
            <h3>{{ 'product.product-choose' | translate }}</h3>
        </div>
    </div>
}
